import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import cn from "classnames";
import PropTypes from "prop-types";

const Topics = ({ topics }) => {
    const [activeTopic, setActiveTopic] = useState(1);
    const isBigScreen = useMediaQuery({ query: "(min-device-width: 769px)" });

    const renderTopicContent = (number, name) => (
        <div className={"topic__theme"}>
            <span className="topics__number">Тема {number}</span>
            <span className="topics__name">{name}</span>
        </div>
    );

    const renderDesktopThemes = () =>
        topics.map(
            (item, index) =>
                item && (
                    <div
                        className={cn("topics__block", { topic__selected: index === activeTopic })}
                        key={JSON.stringify(item)}
                        onClick={() => setActiveTopic(index)}
                    >
                        {renderTopicContent(index, item.topic.name)}
                    </div>
                )
        );

    const renderMobileThemes = () =>
        topics.map(
            (item, index) =>
                item && (
                    <a className="topics__block" href={item.topic.url} key={JSON.stringify(item)}>
                        {renderTopicContent(index, item.topic.name)}
                    </a>
                )
        );

    const renderLessons = () =>
        topics[activeTopic].lessons.map(
            (lesson, index) =>
                lesson && (
                    <div className="topics__block" key={JSON.stringify(lesson)}>
                        <a href={lesson.url}>
                            <div className="topic__lesson">
                                <span className="topics__number">
                                    Тема {activeTopic}. Урок {index}
                                </span>
                                <span className="topics__name">{lesson.name}</span>
                            </div>
                        </a>
                    </div>
                )
        );

    return (
        <div className="topics">
            <div className="topics__themes">
                {isBigScreen ? renderDesktopThemes() : renderMobileThemes()}
            </div>
            <div className="topics__lessons">{renderLessons()}</div>
        </div>
    );
};

Topics.propTypes = {
    topics: PropTypes.array,
};

export default Topics;



// WEBPACK FOOTER //
// ./app/frontend/components/Topics.js